import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {CompanySettlementEntity, transportMethod} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit, IconLayersDifference} from "@tabler/icons-react";

export type CompanySettlementAction = "TICKET_COMPARE" | "EDIT"

export type CompanySettlementActionMenuDropdownProps = {
  settlement: CompanySettlementEntity
  onActionClick?: (action: CompanySettlementAction) => void
}

export const CompanySettlementActionMenuDropdown = (props: CompanySettlementActionMenuDropdownProps) => {
  const {settlement, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<CompanySettlementAction> = useMemo(() => {
    const actions = new Set<CompanySettlementAction>()

    if (settlement.method === transportMethod.trucking) {
      actions.add("TICKET_COMPARE")
    }

    if (hasAccess("companysettlement_edit")) {
      actions.add("EDIT")
    }

    return actions
  }, [settlement, hasAccess])

  const _onActionClick = useCallback((action: CompanySettlementAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("TICKET_COMPARE") &&
        <>
          {actions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("TICKET_COMPARE")}
            icon={<IconLayersDifference size={14}/>}>
            {t("common.action.compare", "Compare")}
          </Menu.Item>
        </>
      }
    </>
  )
}
